// Layout and sizing constants
export const LAYOUT = {
  // Container widths
  maxWidth: 1400,
  cardMaxWidth: 400,
  minColumnWidth: 350,
  
  // Heights
  headerHeight: 60,
  minColumnHeight: 500,
  expandedColumnHeight: 600,
  weekCellMinHeight: 60,
  monthCellAspectRatio: 1,
  
  // Spacing (in pixels)
  spacing: {
    xs: 4,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 20,
    xxl: 24,
    xxxl: 30,
  },
  
  // Border radius
  borderRadius: {
    sm: 4,
    md: 6,
    lg: 8,
    xl: 12,
    xxl: 16,
    round: 20,
    full: '50%',
  },
  
  // Font sizes
  fontSize: {
    xs: '0.75rem',    // 12px
    sm: '0.85rem',    // 13.6px
    md: '0.9rem',     // 14.4px
    lg: '1rem',       // 16px
    xl: '1.1rem',     // 17.6px
    xxl: '1.25rem',   // 20px
    xxxl: '1.8rem',   // 28.8px
    display: '64px',
  },
  
  // Breakpoints
  breakpoints: {
    mobile: 768,
    tablet: 1024,
    desktop: 1200,
    wide: 1400,
  },
};

// Slider and pagination constants
export const SLIDER_CONFIG = {
  classesPerSlide: 1,
  coursesPerSlide: 1,
  swipeThreshold: 50,
  transitionDuration: '0.3s',
  classesPreviewLimit: 5,
};

// Touch gesture constants
export const TOUCH_CONFIG = {
  swipeThreshold: 50,
  swipeVelocityThreshold: 0.3,
};

// Search constants
export const SEARCH_CONFIG = {
  defaultMinPrice: 0,
  defaultMaxPrice: 1000,
  popularSubjectsLimit: 6,
  searchResultsPreviewLimit: 3,
  defaultSessionType: '',
};

// Display limits
export const DISPLAY_LIMITS = {
  popularSubjects: 6,
  searchResultsPreview: 3,
  classesPreview: 5,
  moreIndicatorThreshold: 3,
};

// Calendar constants
export const CALENDAR_CONFIG = {
  weekDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  weekDaysShort: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  defaultView: 'week' as const,
  maxSessionsVisible: 3,
  sessionListMaxHeight: 200,
};

// Button sizes
export const BUTTON_SIZES = {
  iconButton: 32,
  dotSize: 8,
  dotSizeActive: 24,
  sessionCountSize: 20,
  closeButtonSize: 24,
};

// Z-index levels
export const Z_INDEX = {
  base: 0,
  dropdown: 10,
  sticky: 20,
  fixed: 30,
  modalBackdrop: 40,
  modal: 50,
  popover: 60,
  tooltip: 70,
  floatingAction: 1000,
};